export const createNavbarSections = (tabs, funcClasses, scroll = false) => {
  if (!tabs) {
    return []
  }

  return tabs
    .filter((tab) => !tab.insights_list && !tab.insights_panel)
    .map((tab) => {
      const isSplashTab = !!tab.product_splash
      const ticker = funcClasses?.[0]?.ticker || ''
      const product_type =
        funcClasses?.[0]?.share_class?.[0]?.product_type?.toLowerCase() || ''

      const values = Object.values(tab)

      const tab_section = values.find((val) => val !== null)

      if (!tab_section) {
        return null
      }

      const id = `#${tab_section.title.replace(' ', '')}`

      return isSplashTab || scroll
        ? { name: tab_section.title, id }
        : { name: tab_section.title, path: `/${product_type}/${ticker}${id}` }
    })
    .filter((section) => section !== null)
}

export const mapApiComponent = (api) => {
  switch (api?.component) {
    case 'PriceHistorySearch':
      return 'PriceHistorySearchForm'
    case 'FundPerformanceWithChart':
      return 'TotalReturnsWrapper'
    case 'FundOverviewPerformanceTable':
      return 'AnnualizedReturns'
    case 'FundPeriodicPerformanceWithChart':
      return 'PeriodicTotalReturnsWrapper'
    default:
      return api?.component
  }
}
